module.exports = __webpack_public_path__ + "static/media/FOTO 3.1.cd068622.png";